import React, { useState, useEffect } from "react";
import { FaRegCalendarAlt, FaRegEdit } from "react-icons/fa";
import { MdDeleteOutline } from "react-icons/md";
import { IoMdInformationCircleOutline } from "react-icons/io";
import {
    DndContext,
    closestCenter
} from "@dnd-kit/core";

import {
    arrayMove,
    SortableContext,
    useSortable,
    verticalListSortingStrategy
} from "@dnd-kit/sortable";

import { CSS } from "@dnd-kit/utilities";
import TiptapEditor from "./TipTapEditor";




const DodajKoncerte = () => {
    const [ime, setIme] = useState("");
    const [podnaslov, setPodnaslov] = useState("");
    const [datum, setDatum] = useState("");
    const [lokacija, setLokacija] = useState("");
    const [vsebina, setVsebina] = useState("");
    const [rezervacijeOmogocene, setRezervacijeOmogocene] = useState(true);
    const [programItems, setProgramItems] = useState([
        { skladatelj: "", naslov: "", stavki: [{ vrstniRed: 1, naslov: "" }] }
    ]);
    const [cikel, setCikel] = useState("");
    const [slike, setSlike] = useState([]);
    const [obstojeceSlike, setObstojeceSlike] = useState([]); // že naložene slike
    const [seShranjuje, setSeShranjuje] = useState(false);
    const [trajanje, setTrajanje] = useState({
        ure: "0",
        minute: "00"
    });
    const [programskiList, setProgramskiList] = useState("");

    const [skupine, setSkupine] = useState([{ imeSkupine: "", izvajalci: [{ ime: "", instrument: "" }] }]);

    const handleSlikaChange = (e) => {
        setSlike([...e.target.files]);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setSeShranjuje(true);

        const formData = new FormData();
        formData.append("ime", ime);
        formData.append("podnaslov", podnaslov);
        formData.append("datum", datum);
        formData.append("lokacija", lokacija);
        formData.append("vsebina", vsebina);
        formData.append("program", JSON.stringify(programItems));
        formData.append("cikel", cikel);
        formData.append("rezervacijeOmogocene", rezervacijeOmogocene);
        // obstoječe slike (stringi s potjo v bazi)
        formData.append("obstojeceSlike", JSON.stringify(obstojeceSlike));
        formData.append(
            "trajanje",
            `${trajanje.ure}:${trajanje.minute.padStart(2,"0")}`
        );
        formData.append("programskiList", programskiList);

        // nove slike (fajli)
        slike.forEach((slika) => {
            formData.append("slike", slika);
        });


        // Poslano bo kot seznam skupin z izvajalci
        formData.append("izvajalci", JSON.stringify(skupine));


        try {
            const url = editingKoncertId
                ? `${process.env.REACT_APP_BACKEND_URL}/koncerti/uredi/${editingKoncertId}`
                : `${process.env.REACT_APP_BACKEND_URL}/koncerti/dodaj`;

            const method = editingKoncertId ? "PUT" : "POST";

            const response = await fetch(url, {
                method,
                body: formData,
            });

            if (response.ok) {
                alert(editingKoncertId ? "Koncert uspešno posodobljen!" : "Koncert uspešno dodan!");
                setEditingKoncertId(null); // Reset
                // Po potrebi sprazni formo
            } else {
                const errorResponse = await response.json();
                alert("Napaka: " + errorResponse.message);
            }
        } catch (error) {
            console.error("Napaka pri pošiljanju podatkov:", error);
            alert("Napaka pri pošiljanju podatkov.");
        } finally {
            setSeShranjuje(false);
        }
    };


    const handleAddSkupina = () => {
        setSkupine([...skupine, { imeSkupine: "", izvajalci: [{ ime: "", instrument: "" }] }]);
    };

    const handleRemoveSkupina = (index) => {
        const newSkupine = [...skupine];
        newSkupine.splice(index, 1);
        setSkupine(newSkupine);
    };

    const handleSkupinaChange = (index, field, value) => {
        const newSkupine = [...skupine];
        newSkupine[index][field] = value;
        setSkupine(newSkupine);
    };

    const handleAddIzvajalec = (skupinaIndex) => {
        const newSkupine = [...skupine];
        newSkupine[skupinaIndex].izvajalci.push({ ime: "", instrument: "" });
        setSkupine(newSkupine);
    };

    const handleRemoveIzvajalec = (skupinaIndex, izvajalecIndex) => {
        const newSkupine = [...skupine];
        newSkupine[skupinaIndex].izvajalci.splice(izvajalecIndex, 1);
        setSkupine(newSkupine);
    };

    const handleIzvajalecChange = (skupinaIndex, izvajalecIndex, field, value) => {
        const newSkupine = [...skupine];
        newSkupine[skupinaIndex].izvajalci[izvajalecIndex][field] = value;
        setSkupine(newSkupine);
    };

    const handleProgramChange = (index, field, value) => {
        const newProgram = [...programItems];
        newProgram[index][field] = value;
        setProgramItems(newProgram);
    };

    const handleStavekChange = (programIdx, stavekIdx, field, value) => {
        const newProgram = [...programItems];
        newProgram[programIdx].stavki[stavekIdx][field] = value;
        setProgramItems(newProgram);
    };

    const addStavek = (programIdx) => {
        const newProgram = [...programItems];
        newProgram[programIdx].stavki.push({ vrstniRed: 1, naslov: "" });
        setProgramItems(newProgram);
    };

    const addProgramItem = () => {
        setProgramItems([
            ...programItems,
            {
                skladatelj: "",
                naslov: "",
                stavki: [{ vrstniRed: 1, naslov: "" }]
            }
        ]);
    };

    const handleRemoveStavek = (itemIndex, stavekIndex) => {
        setProgramItems((prev) => {
            const novi = [...prev];
            novi[itemIndex].stavki.splice(stavekIndex, 1);
            return novi;
        });
    };



    const handleRemoveProgramItem = (itemIndex) => {
        setProgramItems((prev) => prev.filter((_, i) => i !== itemIndex));
    };


    const [editingKoncertId, setEditingKoncertId] = useState(null);

    const naloziKoncertZaUrejanje = async (id) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/koncerti/${id}`);
            const data = await response.json();

            setIme(data.ime || "");
            setPodnaslov(data.podnaslov || "");
            setDatum(
                data.datum
                    ? new Date(new Date(data.datum).getTime() - new Date().getTimezoneOffset() * 60000)
                        .toISOString()
                        .slice(0, 16)
                    : ""
            );
            setLokacija(data.lokacija || "");
            setVsebina(data.vsebina || "");
            setProgramItems(
                Array.isArray(data.program)
                    ? data.program.map(item => ({
                        ...item,
                        stavki: Array.isArray(item.stavki)
                            ? item.stavki.map((s, i) =>
                                typeof s === "string"
                                    ? { vrstniRed: i + 1, naslov: s }
                                    : s
                            )
                            : [{ vrstniRed: 1, naslov: "" }]
                    }))
                    : [{ skladatelj: "", naslov: "", stavki: [{ vrstniRed: 1, naslov: "" }] }]
            );
            setSkupine(Array.isArray(data.izvajalci) ? data.izvajalci : [{ imeSkupine: "", izvajalci: [{ ime: "", instrument: "" }] }]);
            setCikel(data.cikel || "");
            setEditingKoncertId(id);
            setRezervacijeOmogocene(data.rezervacijeOmogocene ?? true);
            setObstojeceSlike(data.slike || []);
            setSlike([]); // počisti nove
            setProgramskiList(data.programskiList || "");
            const [ure, minute] = data.trajanje.split(":");

            setTrajanje({
                ure,
                minute
            });
        } catch (error) {
            console.error("Napaka pri nalaganju koncerta:", error);
        }
    };



    const [koncerti, setKoncerti] = useState([]);

    useEffect(() => {
        const fetchKoncerti = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/koncerti`);
                const data = await response.json();
                if (Array.isArray(data)) {
                    setKoncerti(data);
                } else {
                    console.error("Pričakoval array, dobil:", data);
                    setKoncerti([]); // fallback na prazen array
                }
            } catch (error) {
                console.error("Napaka pri pridobivanju koncertov:", error);
                setKoncerti([]); // fallback na prazen array
            }
        };
        fetchKoncerti();
    }, []);


    function formatirajDatum(datum) {
        const meseci = ["januar", "februar", "marec", "april", "maj", "junij", "julij", "avgust", "september", "oktober", "november", "december"];
        const date = new Date(datum);
        return `${date.getDate()}. ${meseci[date.getMonth()]} ob ${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
    }

    function SortableImage({ slika, index, odstraniSliko }) {
        const { attributes, listeners, setNodeRef, transform, transition } =
            useSortable({ id: slika });

        const style = {
            transform: CSS.Transform.toString(transform),
            transition,
            position: "relative",
            display: "inline-block"
        };

        return (
            <div ref={setNodeRef} style={style} {...attributes}>
                <img
                    src={slika}
                    alt="slika"
                    {...listeners}
                    style={{
                        width: "120px",
                        height: "80px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        cursor: "grab"
                    }}
                />

                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        odstraniSliko(index);
                    }}
                    style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        background: "red",
                        color: "white",
                        border: "none",
                        borderRadius: "50%",
                        cursor: "pointer"
                    }}
                >
                    ✕
                </button>
            </div>
        );
    }

    const handleDragEnd = (event) => {
        const { active, over } = event;

        if (!over || active.id === over.id) return;

        const oldIndex = obstojeceSlike.indexOf(active.id);
        const newIndex = obstojeceSlike.indexOf(over.id);

        setObstojeceSlike((items) => arrayMove(items, oldIndex, newIndex));
    };


    const [pokaziModal, setPokaziModal] = useState(false);
    const [izbranIdZaBrisanje, setIzbranIdZaBrisanje] = useState(null);

    const potrdiBrisanje = (id) => {
        setIzbranIdZaBrisanje(id);
        setPokaziModal(true);
    };
    const odstraniSliko = (index) => {
        setObstojeceSlike(prev => prev.filter((_, i) => i !== index));
    };

    const izbrisiKoncert = async (id) => {
        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/koncerti/${id}`, {
                method: "DELETE",
            });

            if (!res.ok) {
                const msg = await res.json();
                alert(`Napaka: ${msg.message}`);
                return;
            }

            alert("Koncert uspešno izbrisan!");
            setKoncerti(prev => prev.filter(k => k._id !== id));
        } catch (err) {
            console.error("Napaka pri brisanju:", err);
            alert("Napaka pri brisanju koncerta.");
        } finally {
            setPokaziModal(false);
        }
    };





    return (
            <div>
                {pokaziModal && (
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <h3>A si ziher da bi izbrisal ta koncert?</h3>
                            <div className="modal-buttons">
                                <button onClick={() => izbrisiKoncert(izbranIdZaBrisanje)} className="potrdi"><MdDeleteOutline />Mhm</button>
                                <button onClick={() => setPokaziModal(false)} className="preklici">Ne!</button>
                            </div>
                        </div>
                    </div>
                )}
            <div className="dodaj-koncert">
                <h2>Dodaj Koncert</h2>

                <form onSubmit={handleSubmit}>
                    <input type="text" placeholder="Ime koncerta" value={ime} onChange={(e) => setIme(e.target.value)} required />
                    <input
                        type="text"
                        placeholder="Podnaslov"
                        value={podnaslov}
                        onChange={(e) => setPodnaslov(e.target.value)}
                    />

                    <input type="datetime-local" value={datum} onChange={(e) => setDatum(e.target.value)} required />
                    <textarea placeholder="Lokacija" value={lokacija} onChange={(e) => setLokacija(e.target.value)} required />
                    <h3 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        Vsebina
                        <span className="tooltip">
                            <IoMdInformationCircleOutline />

                            <span className="tooltip-text">
                                Za link izberi tekst in klikni Dodaj Link :D
                            </span>
                        </span>
                    </h3>
                    <TiptapEditor
                        value={vsebina}
                        onChange={setVsebina}
                    />
                    <div>
                        <h3 style={{ marginBottom: "10px"  }}>Program</h3>
                        {programItems.map((item, index) => (
                            <div key={index}>
                                <input
                                    type="text"
                                    placeholder="Skladatelj"
                                    value={item.skladatelj}
                                    onChange={(e) => handleProgramChange(index, "skladatelj", e.target.value)}
                                    required
                                />
                                <input
                                    type="text"
                                    placeholder="Naslov"
                                    value={item.naslov}
                                    onChange={(e) => handleProgramChange(index, "naslov", e.target.value)}
                                    required
                                />
                                {item.stavki.map((stavek, stavekIdx) => (
                                    <div key={stavekIdx}>
                                        <input
                                            type="number"
                                            min="1"
                                            placeholder="Št."
                                            value={stavek.vrstniRed}
                                            onChange={(e) =>
                                                handleStavekChange(index, stavekIdx, "vrstniRed", Number(e.target.value))
                                            }
                                            style={{ width: "70px" }}
                                        />

                                        <input
                                            type="text"
                                            placeholder="Naslov stavka"
                                            value={stavek.naslov}
                                            onChange={(e) =>
                                                handleStavekChange(index, stavekIdx, "naslov", e.target.value)
                                            }
                                        />
                                        <button
                                            className="odstrani"
                                            type="button"
                                            onClick={() => handleRemoveStavek(index, stavekIdx)}
                                        >
                                            Odstrani stavek
                                        </button>
                                    </div>
                                ))}
                                <button className="dodaj-gumb" type="button" onClick={() => addStavek(index)}>
                                    Dodaj stavek
                                </button>
                                <button
                                    className="odstrani"
                                    type="button"
                                    onClick={() => handleRemoveProgramItem(index)}
                                >
                                    Odstrani skladbo
                                </button>
                            </div>
                        ))}
                        <button className="dodaj-gumb" type="button" onClick={addProgramItem}>
                            Dodaj skladbo
                        </button>

                    </div>


                    {/* Dodajanje skupin z izvajalci */}
                    <h3>Izvajalci</h3>
                    <div>
                        {skupine.map((skupina, skupinaIndex) => (
                            <div key={skupinaIndex}>
                                <input
                                    type="text"
                                    placeholder="Ime skupine"
                                    value={skupina.imeSkupine}
                                    onChange={(e) => handleSkupinaChange(skupinaIndex, "imeSkupine", e.target.value)}
                                />
                                {skupina.izvajalci.map((izvajalec, izvajalecIndex) => (
                                    <div key={izvajalecIndex}>
                                        <input
                                            type="text"
                                            placeholder="Ime izvajalca"
                                            value={izvajalec.ime}
                                            onChange={(e) => handleIzvajalecChange(skupinaIndex, izvajalecIndex, "ime", e.target.value)}
                                            required
                                        />
                                        <input
                                            type="text"
                                            placeholder="Inštrument"
                                            value={izvajalec.instrument}
                                            onChange={(e) => handleIzvajalecChange(skupinaIndex, izvajalecIndex, "instrument", e.target.value)}
                                            required
                                        />
                                        <button className="odstrani" type="button" onClick={() => handleRemoveIzvajalec(skupinaIndex, izvajalecIndex)}>Odstrani izvajalca</button>
                                    </div>
                                ))}
                                <button className="dodaj-gumb" type="button" onClick={() => handleAddIzvajalec(skupinaIndex)}>Dodaj izvajalca</button>
                                <button className="odstrani" type="button" onClick={() => handleRemoveSkupina(skupinaIndex)}>Odstrani skupino</button>
                            </div>
                        ))}
                        <button className="dodaj-gumb" type="button" onClick={handleAddSkupina}>Dodaj skupino</button>
                    </div>

                    <h3>Programski list</h3>

                    <TiptapEditor
                        value={programskiList}
                        onChange={setProgramskiList}
                    />

                    <h3>Trajanje koncerta</h3>
                    <div className="trajanje-picker">
                        <select
                            value={trajanje.ure}
                            onChange={(e)=>
                                setTrajanje({
                                    ...trajanje,
                                    ure:e.target.value
                                })
                            }
                        >
                            {Array.from({length:8},(_,i)=>(
                                <option key={i} value={i}>
                                    {i} h
                                </option>
                            ))}
                        </select>

                        <select
                            value={trajanje.minute}
                            onChange={(e)=>
                                setTrajanje({
                                    ...trajanje,
                                    minute:e.target.value
                                })
                            }
                        >
                            {Array.from({length:60},(_,i)=>(
                                <option key={i} value={i}>
                                    {i.toString().padStart(2,"0")} min
                                </option>
                            ))}
                        </select>
                    </div>

                    <h3>Cikel</h3>
                    <select value={cikel} onChange={(e) => setCikel(e.target.value)}>
                        <option value="">- Brez cikla -</option>
                        <option value="mlada klasika">Mlada Klasika</option>
                        <option value="mlada kreativa">Mlada Kreativa</option>
                        <option value="gostuje">Gostuje</option>
                        <option value="glasbaMladih">glasba mladih</option>
                        <option value="kultura v atrijih">kultura v atrijih</option>
                    </select>

                    <label className="switch-wrapper">
                        <label className="switch">
                            <input
                                type="checkbox"
                                checked={rezervacijeOmogocene}
                                onChange={(e) => setRezervacijeOmogocene(e.target.checked)}
                            />
                            <span className="slider"></span>
                        </label>
                        <span>Omogoči rezervacije za ta koncert</span>
                    </label>


                    <input type="file" multiple onChange={handleSlikaChange} />
                    {obstojeceSlike.length > 0 && (
                        <div style={{ marginTop: "1em" }}>
                            <h3>Obstoječe slike (povleci za vrstni red):</h3>

                            <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                                <SortableContext
                                    items={obstojeceSlike}
                                    strategy={verticalListSortingStrategy}
                                >
                                    <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                        {obstojeceSlike.map((slika, index) => (
                                            <SortableImage
                                                key={slika}
                                                slika={slika}
                                                index={index}
                                                odstraniSliko={odstraniSliko}
                                            />
                                        ))}
                                    </div>
                                </SortableContext>
                            </DndContext>
                        </div>
                    )}
                    {seShranjuje && <h3 style={{ color: "green", fontWeight: "bold" }}>Evo se shranjuje :D...</h3>}
                    <button type="submit">Shrani koncert</button>
                </form>
            </div>


            <h1 className="center" style={{ marginTop: "1em" }}>Urejanje koncertov:</h1>
            <div className="spreminjanje-koncertov center">
                <div className="center spreminjanje-koncertov-blabla">
                    {Array.isArray(koncerti) && koncerti
                        .slice()
                        .sort((a, b) => new Date(b.datum) - new Date(a.datum))
                        .map((koncert) => (
                            <div key={koncert._id} className="spreminjanje-koncertov-karta">
                                <img className="dodajanje-slika" src={koncert.slike?.[0] || "/fallback.jpg"} alt={koncert.ime} />
                                <div className="maxWidth">
                                    <p><FaRegCalendarAlt style={{ marginRight: "10px" }} />{formatirajDatum(new Date(koncert.datum))}</p>
                                    <h2><b>{koncert.ime}</b></h2>
                                </div>
                                <div className="center mal-gapa" style={{ position: "relative", marginLeft: "auto" }}>
                                    <button
                                        className="center"
                                        type="button"
                                        onClick={() => {
                                            naloziKoncertZaUrejanje(koncert._id);
                                            window.scrollTo({ top: 0, behavior: "smooth" }); // poscrolla lepo na vrh
                                        }}
                                    >
                                        <FaRegEdit style={{ marginRight: "8px" }} /> Uredi
                                    </button>
                                    <button
                                        className="center izbris-gumb"
                                        type="button"
                                        onClick={() => potrdiBrisanje(koncert._id)}
                                    >
                                        <MdDeleteOutline /> Odstrani
                                    </button>
                                </div>

                            </div>
                        ))
                    }
                </div>
            </div>



        </div>
    );
};

export default DodajKoncerte;
